import React from 'react';
import { Stack } from '@mui/material';
import Avatar from '../Shared/Avatar';

const WorkspaceItem = (props) => {
  return <Stack direction="row" gap={2} sx={{alignItems: 'center'}}>
    <Avatar workspace={props.workspace} />
    <Stack>
      <p>{props.workspace.name}</p>
      <small className="text-secondary">{props.workspace.members} members</small>
    </Stack>
  </Stack>
}

export default WorkspaceItem;